import { Box, useTheme } from "@mui/material"
import BaseCard from "../../../theme/cards/BaseCard"
import { tokens } from "../../../../theme";
import Text from "../../../theme/text/Text";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import ShLabel from "../../../theme/label/ShLabel";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import { getOrderStateData } from "../../../../utils/labelColorText";
import { useSelector } from "react-redux";
import { ENV_TYPES } from "../../../global/Sidebar";
import CheckBox from '@mui/icons-material/CheckBox';        // Checked box icon (Yes)
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank'; // Empty box icon (No)

const OrdersCard = (props) => {
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [send, setSend] = useState(null);
    const [planned, setPlanned] = useState(null);
    const [statusColor, setStatusColor] = useState("blue");
    const [statusText, setStatusText] = useState("");
    // const solved = props.row.solved ?? false;
    // const solvedColor = solved ? "green" : "red";

    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];

    const [plannedColor, setPlannedColor] = useState("grey");

    
    useEffect(() => {
        // console.log("skellytime",props.skeleton);
        if(!props.skeleton) {
            let planned = new Date(props.date_planned);
            let sent = props.date_sent ? new Date(props.date_sent) : null;

            setSend(sent);
            setPlanned(new Date(props.date_planned));
        
            if(sent) {
                // when sent is filled and is equal to planned: green
                if(sent.getTime() === planned.getTime()) {
                    // labelcolor = "green";
                    setPlannedColor("green");
                }
                // when sent is filled but later than planned: orange
                else if(sent.getTime() > planned.getTime()) {
                    // labelcolor = "orange";
                    setPlannedColor("orange");
                }
            }
            else {
                // When sent is not filled and planned >= now: blue
                if(planned.getTime() >= Date.now()) {
                    setPlannedColor("blue");
                }
                // When sent is not filled and planned < now: red
                else if(planned.getTime() < Date.now()) {
                    setPlannedColor("red");
                }
            }
            const { labelcolor, labeltext } = getOrderStateData(props.state, theme, isRelation, props.snoozeWhenAvailable);
            setStatusColor(labelcolor);
            setStatusText(labeltext);
              
        }
    },[props.skeleton])
    const handleToggle = (e) => {
        e.stopPropagation();
        props.select(props.id)
    };
   

    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box
                >
                    <Box display={"flex"} flexDirection={"column"}>
                        {props.skeleton ? 
                            <ShDoubleTextSkeleton/> 
                            :
                            <>
                                <Text bold>{props.barcode ?? props.id}</Text>
                                {isRelation ?
                                    <Text>{`${props.webshopcredentials?.description ?? t("self_created")} - ${props.webshopreference} (${props.deliveryCountry ? props.deliveryCountry.toUpperCase() : ""})`}</Text>
                                : 
                                    <Text>{`${props.relation?.name} - ${props.webshopreference} (${props.deliveryCountry ? props.deliveryCountry.toUpperCase() : ""})`}</Text>
                                }
                            </>
                        }
                    </Box>
                    <TopRight>
                        {/* <ShLabel fitted borderless palette={"normal"} size={32} variant={props.skeleton ? "grey" : plannedColor}  position="child-b">
                            {props.skeleton ?null : t(statusText)}
                        </ShLabel> */}

                        <CardLabel 
                            variant={props.skeleton ? "grey" : statusColor}  
                            position="child-tr"
                            hasright={props.selectable}
                        >
                            {props.skeleton ? 
                                <ShDoubleTextSkeleton/> 
                                :
                                <>
                                    <Text bold variant={props.skeleton ? "grey" : statusColor}>
                                    {props.skeleton ?null : t(statusText)}
                                    </Text>
                                </>
                            }
                        </CardLabel>
                        {props.selectable &&
                            <Box 
                                onClick={handleToggle} 
                                sx={{ 
                                    borderTopRightRadius:12,
                                    borderBottomLeftRadius:0,
                                    borderTopLeftRadius:0,
                                    borderBottomRightRadius:6,
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent:'center',
                                    cursor: 'pointer',
                                    width:40,
                                    height:32,
                                    background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100]
                                }}
                            >
                                {/* CheckBoxOutlineBlank for "No", CheckBox for "Yes" */}
                                {props.selected ? <CheckBox sx={{ fontSize: 24, fill: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]}} /> : <CheckBoxOutlineBlank sx={{ fontSize: 24, color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400] }} />}
                            </Box>
                        }
                    </TopRight>

                    <Box marginTop={3} display={"flex"} alignItems={"flex-start"} gap={3} overflow={"hidden"}>
                        <Box display={"flex"} flexDirection={"column"} maxWidth={isRelation ? null :100}>
                            <Text light>{isRelation ? t("name") : t("delivery_name")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Text noBreak>
                                    {props.deliveryName}
                                    {/* {myDate} */}
                                    {/* {props.stock && props.stock.total_quantity ? props.stock.total_quantity : 0}     */}
                                </Text>
                            }
                        </Box>
                        {!isRelation && 
                            <Box display={"flex"} flexDirection={"column"} maxWidth={85}>
                                <Text light>{t("stream")}</Text>

                                {props.skeleton ?
                                    <ShTextSkeleton />
                                    :
                                    <Text noBreak>
                                        {props.stream?.shortName}
                                        {/* {myDate} */}
                                        {/* {props.stock && props.stock.total_quantity ? props.stock.total_quantity : 0}     */}
                                    </Text>
                                }
                            </Box>
                        }

                        <Box display={"flex"} flexDirection={"column"} maxWidth={isRelation ? null : 85}>
                            <Text noBreak light>{t("date_planned_shipment")}</Text>

                            {props.skeleton ?
                                <ShTextSkeleton />
                                :
                                <Text bold variant={plannedColor}>
                                    
                                    {!send && planned?.toLocaleDateString(i18n.language)}
                                    {send && send?.toLocaleDateString(i18n.language)}
                                    {/* {myDate} */}
                                    {/* {props.stock && props.stock.total_quantity ? props.stock.total_quantity : 0}     */}
                                </Text>
                            }
                        </Box>

                    </Box>

                    
                </Box>
            </Box>
        </BaseCard>
    )
}

export default OrdersCard;